import {
  CalculatorRate,
  ContentBlock,
  DocumentItem,
  FooterColumn,
  NavLink,
  NewsItem,
  Page,
  Service,
  SiteSettings,
  Statistic,
} from '../types/content';
import bannerImage from '../components/assets/1.jpg';
import serviceImageA from '../components/assets/2.jpg';
import serviceImageB from '../components/assets/11.jpg';
import serviceImageC from '../components/assets/522.png';

export const DEFAULT_NAV: NavLink[] = [
  { label: 'Hizmetler', path: '/hizmetler' },
  { label: 'Hakkımızda', path: '/hakkimizda' },
  { label: 'Liman Özellikleri', path: '/liman-ozellikleri' },
  { label: 'Haberler', path: '/haberler' },
  { label: 'Kariyer', path: 'https://kariyer.sanshine.com.tr/Liman/' },
  { label: 'Sürdürülebilirlik', path: '/surdurulebilirlik' },
];

export const DEFAULT_QUICKLINKS: NavLink[] = [
  { label: 'Konteyner', path: '/hizmetler' },
  { label: 'Genel Kargo / Dökme Yük', path: '/hizmetler' },
  { label: 'Proje Kargo', path: '/hizmetler' },
  { label: 'Antrepo, Depo ve Silo', path: '/hizmetler' },
  { label: 'Atık Alım', path: '/hizmetler' },
];

export const DEFAULT_FOOTER_COLUMNS: FooterColumn[] = [
  {
    title: 'Hizmetler',
    links: [
      { label: 'Konteyner', path: '/hizmetler' },
      { label: 'Dökme Yük / Genel Kargo', path: '/hizmetler' },
      { label: 'Proje Kargo', path: '/hizmetler' },
      { label: 'Depolama', path: '/liman-ozellikleri' },
      { label: 'Atık Alım', path: '/hizmetler' },
    ],
  },
  {
    title: 'Kurumsal',
    links: [
      { label: 'Hakkımızda', path: '/hakkimizda' },
      { label: 'Sürdürülebilirlik', path: '/surdurulebilirlik' },
      { label: 'Kariyer', path: '/kariyer' },
      { label: 'Liman Özellikleri', path: '/liman-ozellikleri' },
      { label: 'Haberler', path: '/haberler' },
    ],
  },
  {
    title: 'Destek',
    links: [
      { label: 'Liman Rehberi', path: '/liman-ozellikleri' },
      { label: 'Tarifeler', path: '/' },
      { label: 'SSS', path: '/' },
      { label: 'İletişim', path: '/iletisim' },
      { label: 'Online Hizmetler', path: '/' },
    ],
  },
];

const IMG = {
  hero: bannerImage,
  aerial: serviceImageA,
  crane: serviceImageA,
  containers: serviceImageB,
  map: serviceImageA,
  green: serviceImageC,
  team: serviceImageB,
  warehouse: serviceImageC,
  iso: serviceImageB,
};

export const DEFAULT_SETTINGS: SiteSettings = {
  siteName: 'TBH Port Adana',
  slogan: 'Ticaret Dürüstlük Üzerine Kuruludur',
  topbarAddress: 'Sugözü, 01682 Yumurtalık / Adana',
  footerAddress: 'Sugözü, 01682 Yumurtalık / Adana',
  footerPhone: '+90 (322) 000 00 00',
  footerEmail: 'info@tbhport.com',
  footerNote: "Akdeniz'in güçlü liman operatörü olarak bölge ticaretine değer katıyoruz.",
  navigation: DEFAULT_NAV,
  quickLinks: DEFAULT_QUICKLINKS,
  footerColumns: DEFAULT_FOOTER_COLUMNS,
  onlineServicesUrl: 'https://online.tbhport.com',
  socialLinks: [
    { platform: 'LinkedIn', url: 'https://linkedin.com' },
    { platform: 'Twitter', url: 'https://twitter.com' },
  ],
  languages: [
    { code: 'tr', label: 'TR' },
    { code: 'en', label: 'EN' },
  ],
  mapAddress: 'Sugözü, 01682 Yumurtalık / Adana',
  copyrightText: '© 2026 TBH Port Adana – Tüm hakları saklıdır.',
};

export const DEFAULT_PAGES: Page[] = [
  {
    id: 1,
    slug: 'anasayfa',
    title: 'Ana Sayfa',
    heroTitle: 'Ticaret <em>Dürüstlük</em> Üzerine Kuruludur',
    heroSubtitle:
      "Gümrüklü ve gümrüksüz antrepo çözümleri ve 1.300.000 m2 toplam alanı ile ticaretin kesintisiz akışını sağlıyoruz.",
    heroImage: IMG.hero,
    heroCtaText: 'Teklif Al',
    heroCtaLink: '#teklif',
    sortOrder: 0,
    isPublished: true,
  },
  {
    id: 2,
    slug: 'hakkimizda',
    title: 'Hakkımızda',
    heroTitle: 'Ticaret <em>Dürüstlük</em> Üzerine',
    heroSubtitle: "Doğu Akdeniz'in güvenilir liman operatörü olarak bölge ticaretinin merkezindeyiz.",
    heroImage: IMG.aerial,
    sortOrder: 1,
    isPublished: true,
  },
  {
    id: 3,
    slug: 'liman-ozellikleri',
    title: 'Liman Özellikleri',
    heroTitle: 'Çok Amaçlı <em>Liman</em> Altyapısı',
    heroSubtitle: 'Derin rıhtımlar, modern ekipman parkı ve 1.3M m² operasyon sahası.',
    heroImage: IMG.crane,
    sortOrder: 2,
    isPublished: true,
  },
  {
    id: 4,
    slug: 'haberler',
    title: 'Haberler',
    heroTitle: 'Bizden <em>Haberler</em>',
    heroSubtitle: 'Limandan ve sektörden güncel gelişmeler.',
    heroImage: IMG.containers,
    sortOrder: 3,
    isPublished: true,
  },
  {
    id: 5,
    slug: 'surdurulebilirlik',
    title: 'Sürdürülebilirlik',
    heroTitle: 'Doğaya <em>Saygı</em>, İlerlemenin Tek Yolu',
    heroSubtitle: 'Sürdürülebilir liman operasyonları ve ESG taahhütlerimiz.',
    heroImage: IMG.green,
    sortOrder: 4,
    isPublished: true,
  },
  {
    id: 6,
    slug: 'kariyer',
    title: 'Kariyer',
    heroTitle: '<span>Güçlü Bir Gelecek İçin</span> Aynı Rotadayız',
    heroSubtitle:
      'TBH Port Adana olarak büyüyen ekibimize katılmak isteyen adaylara açık pozisyonlar ve genel başvuru imkanı sunuyoruz.',
    heroImage: IMG.team,
    sortOrder: 5,
    isPublished: true,
  },
  {
    id: 7,
    slug: 'iletisim',
    title: 'İletişim',
    heroTitle: 'Bizimle <em>İletişime</em> Geçin',
    heroSubtitle: 'Sorularınız ve teklif talepleriniz için bize ulaşın.',
    heroImage: IMG.map,
    sortOrder: 6,
    isPublished: true,
  },
];

export const DEFAULT_SERVICES: Service[] = [
  {
    id: 1,
    title: 'Konteyner',
    slug: 'konteyner',
    category: 'operasyon',
    description: 'STS vinç operasyonları, reefer altyapısı ve 7/24 kesintisiz konteyner elleçleme.',
    imageUrl: IMG.containers,
    features: ['STS vinç operasyonları', 'Reefer priz altyapısı', '7/24 saha hizmeti'],
    sortOrder: 0,
    isPublished: true,
  },
  {
    id: 2,
    title: 'Genel Kargo / Dökme Yük',
    slug: 'genel-kargo',
    category: 'operasyon',
    description: 'Dökme ve genel kargo yüklerinde yüksek kapasiteli elleçleme çözümleri.',
    imageUrl: IMG.crane,
    features: ['Dökme yük elleçleme', 'Genel kargo', 'Yüksek kapasite'],
    sortOrder: 1,
    isPublished: true,
  },
  {
    id: 3,
    title: 'Proje Kargo',
    slug: 'proje-kargo',
    category: 'operasyon',
    description: 'Ağır lift ve proje kargosu taşımacılığında uzman mühendislik çözümleri.',
    imageUrl: IMG.warehouse,
    features: ['Ağır lift', 'Proje lojistiği', 'Özel rigging'],
    sortOrder: 2,
    isPublished: true,
  },
  {
    id: 4,
    title: 'Antrepo, Depo ve Silo',
    slug: 'depo-antrepo',
    category: 'operasyon',
    description: 'Modern depolama, antrepo ve silo altyapısıyla entegre lojistik.',
    imageUrl: IMG.warehouse,
    features: ['Kapalı / açık depo', 'Antrepo hizmetleri', 'Silo depolama'],
    sortOrder: 3,
    isPublished: true,
  },
  {
    id: 5,
    title: 'Atık Alım',
    slug: 'atik-alim',
    category: 'operasyon',
    description: 'Gemi kaynaklı atıkların çevre mevzuatına uygun toplanması ve bertarafı.',
    imageUrl: IMG.green,
    features: ['MARPOL uyumu', 'Atık toplama', 'Çevresel bertaraf'],
    sortOrder: 4,
    isPublished: true,
  },
];

/** Hero / vurgu istatistikleri (kategori: hero) ve altyapı istatistikleri */
export const DEFAULT_STATISTICS: Statistic[] = [
  { id: 1, category: 'hero', label: 'Yıllık Kapasite', value: '250K TEU', sortOrder: 0 },
  { id: 2, category: 'hero', label: 'Yıllık Kapasite', value: '6M TON', sortOrder: 1 },
  { id: 3, category: 'hero', label: 'Liman Sahası', value: '1.3M m²', sortOrder: 2 },
  { id: 4, category: 'altyapi', label: 'Yıllık Kapasite', value: '250K TEU', sortOrder: 0 },
  { id: 5, category: 'altyapi', label: 'Depolama Alanı', value: '150K m²', sortOrder: 1 },
  { id: 6, category: 'altyapi', label: 'Derinlik', value: '-18 m', sortOrder: 2 },
  { id: 7, category: 'altyapi', label: 'Operasyon', value: '7/24', sortOrder: 3 },
];

export const DEFAULT_DOCUMENTS: DocumentItem[] = [
  { id: 1, title: 'Güncel Konteyner Tarifesi', category: 'PDF - İNDİR', fileUrl: '#', sortOrder: 0, isPublished: true },
  { id: 2, title: 'Diğer Tarifeler', category: 'PDF - İNDİR', fileUrl: '#', sortOrder: 1, isPublished: true },
  { id: 3, title: 'ISO 9001 Kalite Yönetimi', category: 'PDF - SERTİFİKA', fileUrl: '#', sortOrder: 2, isPublished: true },
  { id: 4, title: 'ISO 14001 Çevre Yönetimi', category: 'PDF - SERTİFİKA', fileUrl: '#', sortOrder: 3, isPublished: true },
  { id: 5, title: 'ISO 45001 İş Sağlığı & Güvenliği', category: 'PDF - SERTİFİKA', fileUrl: '#', sortOrder: 4, isPublished: true },
  { id: 6, title: 'ISO 50001 Enerji Yönetimi', category: 'PDF - SERTİFİKA', fileUrl: '#', sortOrder: 5, isPublished: true },
  { id: 7, title: 'Tehlikeli Yük Elleçleme Rehberi', category: 'PDF - TÜRKÇE', fileUrl: '#', sortOrder: 6, isPublished: true },
  { id: 8, title: 'Tehlikeli Yük Elleçleme Rehberi (İngilizce)', category: 'PDF - İNGİLİZCE', fileUrl: '#', sortOrder: 7, isPublished: true },
  { id: 9, title: 'Entegre Yönetim Sistemi Politikası', category: 'PDF - POLİTİKA', fileUrl: '#', sortOrder: 8, isPublished: true },
  { id: 10, title: 'BlueMed Bülteni', category: 'PDF - BÜLTEN', fileUrl: '#', sortOrder: 9, isPublished: true },
  { id: 11, title: 'KVKK Aydınlatma Metni', category: 'PDF - HUKUKİ', fileUrl: '#', sortOrder: 10, isPublished: true },
  { id: 12, title: 'Araç Rezervasyon Kılavuzu', category: 'İZLE - VİDEO', fileUrl: '#', sortOrder: 11, isPublished: true },
];

export const DEFAULT_BLOCKS: ContentBlock[] = [
  {
    pageSlug: 'hakkimizda',
    blockKey: 'vision',
    title: 'Vizyonumuz',
    content: "Doğu Akdeniz'in en güvenilir ve sürdürülebilir liman operatörü olmak.",
    sortOrder: 0,
  },
  {
    pageSlug: 'hakkimizda',
    blockKey: 'mission',
    title: 'Misyonumuz',
    content:
      'Müşterilerimize güvenli, hızlı ve şeffaf liman hizmetleri sunarak bölgesel ticaretin gelişimine katkıda bulunmak.',
    sortOrder: 1,
  },
  {
    pageSlug: 'hakkimizda',
    blockKey: 'values',
    title: 'Değerlerimiz',
    content: 'Dürüstlük, güvenilirlik, şeffaflık ve sürdürülebilirlik tüm operasyonlarımızın temelidir.',
    sortOrder: 2,
  },
  {
    pageSlug: 'surdurulebilirlik',
    blockKey: 'esg_environmental',
    title: 'Çevresel (E)',
    items: ['Karbon ayak izi azaltma', 'Atık yönetimi ve geri dönüşüm', 'Su kaynaklarının korunması', 'Biyoçeşitlilik programları'],
    sortOrder: 0,
  },
  {
    pageSlug: 'surdurulebilirlik',
    blockKey: 'esg_social',
    title: 'Sosyal (S)',
    items: ['İş güvenliği standartları', 'Toplumla ilişkiler', 'Çalışan gelişimi', 'Yerel istihdam desteği'],
    sortOrder: 1,
  },
  {
    pageSlug: 'surdurulebilirlik',
    blockKey: 'esg_governance',
    title: 'Yönetişim (G)',
    items: ['Etik iş uygulamaları', 'Şeffaf raporlama', 'Risk yönetimi', 'Uyum ve denetim'],
    sortOrder: 2,
  },
  {
    pageSlug: 'kariyer',
    blockKey: 'job_links',
    title: 'Açık Pozisyonlar',
    items: ['LinkedIn|https://linkedin.com/jobs', 'Kariyer.net|https://kariyer.net'],
    sortOrder: 0,
  },
  {
    pageSlug: 'kariyer',
    blockKey: 'recruitment_process',
    title: 'İşe Alım Sürecimiz',
    items: [
      'Online başvuru ve CV değerlendirmesi',
      'İnsan kaynakları ön görüşmesi',
      'Teknik / departman görüşmesi',
      'Referans ve belge kontrolü',
      'Teklif ve işe başlangıç',
    ],
    sortOrder: 1,
  },
];

/** Ardiye hesaplayici tarifeleri — portal rateKey ile eslesir */
export const DEFAULT_CALCULATOR_RATES: CalculatorRate[] = [
  { id: 1, rateKey: 'container_20', label: "20' gunluk ucret", value: '34.5', unit: 'USD', category: 'konteyner', sortOrder: 1 },
  { id: 2, rateKey: 'container_40', label: "40' gunluk ucret", value: '50.05', unit: 'USD', category: 'konteyner', sortOrder: 2 },
  { id: 3, rateKey: 'container_45', label: "45' gunluk ucret", value: '57.25', unit: 'USD', category: 'konteyner', sortOrder: 3 },
  { id: 4, rateKey: 'service_import', label: 'Ithalat carpani', value: '1', unit: 'x', category: 'hizmet', sortOrder: 10 },
  { id: 5, rateKey: 'service_transit', label: 'Transit carpani', value: '0.82', unit: 'x', category: 'hizmet', sortOrder: 11 },
  { id: 6, rateKey: 'tier_1_end_day', label: '1. dilim bitis gunu', value: '5', unit: 'gun', category: 'dilim', sortOrder: 20 },
  { id: 7, rateKey: 'tier_1_multiplier', label: '1. dilim carpani', value: '1', unit: 'x', category: 'dilim', sortOrder: 21 },
  { id: 8, rateKey: 'tier_2_end_day', label: '2. dilim bitis gunu', value: '11', unit: 'gun', category: 'dilim', sortOrder: 22 },
  { id: 9, rateKey: 'tier_2_multiplier', label: '2. dilim carpani', value: '1.28', unit: 'x', category: 'dilim', sortOrder: 23 },
  { id: 10, rateKey: 'tier_3_end_day', label: '3. dilim bitis gunu', value: '20', unit: 'gun', category: 'dilim', sortOrder: 24 },
  { id: 11, rateKey: 'tier_3_multiplier', label: '3. dilim carpani', value: '1.9', unit: 'x', category: 'dilim', sortOrder: 25 },
  { id: 12, rateKey: 'tier_4_multiplier', label: '4. dilim carpani', value: '2.35', unit: 'x', category: 'dilim', sortOrder: 26 },
];

export const DEFAULT_NEWS: NewsItem[] = [
  {
    id: 1,
    title: 'TBH Port Adana Kapasite Artırım Projesi Tamamlandı',
    slug: 'kapasite-artirim-projesi',
    summary: 'Liman kapasitesini artıran yatırım projesi başarıyla tamamlandı.',
    content: "TBH Port Adana kapasite artırım projesini tamamladı.",
    imageUrl: IMG.aerial,
    category: 'Yatırım',
    publishedAt: '2026-06-15',
    isFeatured: true,
    isPublished: true,
  },
  {
    id: 2,
    title: 'Yeni STS Vinç Devreye Alındı',
    slug: 'yeni-sts-vinc',
    summary: 'Ekipman parkına eklenen yeni STS vinç ile verimlilik arttı.',
    imageUrl: IMG.crane,
    category: 'Operasyon',
    publishedAt: '2026-05-20',
    isFeatured: false,
    isPublished: true,
  },
  {
    id: 3,
    title: "TBH Port Adana'da ISO Standartları",
    slug: 'iso-standartlari',
    summary: 'ISO 9001, 14001, 45001 ve 50001 sertifikalarımızı yeniledik.',
    imageUrl: IMG.iso,
    category: 'Kurumsal',
    publishedAt: '2026-04-10',
    isFeatured: false,
    isPublished: true,
  },
];
